import api from './api';

const SESSION_KEY = 'wfm_presence_session_id';
const HEARTBEAT_MS = 15 * 60 * 1000;

const apiBaseUrl =
  process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000');

export const getPresenceSessionId = () => {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id =
        typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
          ? crypto.randomUUID()
          : `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch (_) {
    return `s-${Date.now()}`;
  }
};

const postPresence = (payload, { beacon = false } = {}) => {
  const body = JSON.stringify(payload);
  if (beacon && typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
    try {
      const blob = new Blob([body], { type: 'application/json' });
      if (navigator.sendBeacon(`${apiBaseUrl}/api/presence`, blob)) return Promise.resolve();
    } catch (_) {
      /* fall through to fetch */
    }
  }
  if (beacon && typeof fetch === 'function') {
    try {
      void fetch(`${apiBaseUrl}/api/presence`, {
        method: 'POST',
        credentials: 'include',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body
      });
      return Promise.resolve();
    } catch (_) {
      /* ignore */
    }
  }
  return api.post('/api/presence', payload).catch(() => {});
};

/**
 * Track app or PHM surface open/leave/heartbeat in the audit log.
 * Leave uses sendBeacon/keepalive so closing the tab still records without Logout.
 */
export const startPresenceTracking = (surface = 'app') => {
  if (typeof window === 'undefined') return () => {};
  const sessionId = getPresenceSessionId();
  const openedAt = Date.now();
  const surf = surface === 'phm' ? 'phm' : 'app';

  void postPresence({
    event: 'open',
    surface: surf,
    sessionId,
    path: window.location.pathname || ''
  });

  const heartbeatId = window.setInterval(() => {
    void postPresence({
      event: 'heartbeat',
      surface: surf,
      sessionId,
      path: window.location.pathname || ''
    });
  }, HEARTBEAT_MS);

  let left = false;
  const leave = () => {
    if (left) return;
    left = true;
    void postPresence(
      {
        event: 'leave',
        surface: surf,
        sessionId,
        path: window.location.pathname || '',
        durationSec: Math.max(0, Math.round((Date.now() - openedAt) / 1000))
      },
      { beacon: true }
    );
  };

  window.addEventListener('pagehide', leave);
  window.addEventListener('beforeunload', leave);

  return () => {
    window.clearInterval(heartbeatId);
    window.removeEventListener('pagehide', leave);
    window.removeEventListener('beforeunload', leave);
    leave();
  };
};
